import * as React from 'react';

import { useApplicationContext } from '../../context/applicationContext';
import { usePublisher } from '../../hooks';
import { SuperAgentLevelView } from '../../components/SuperAgentLevelView';

export const SuperAgentLevelViewContainer: React.FC = () => {
  const {
    qualityInfo: { isSuperAgent, isSuperHost },
  } = usePublisher();

  const { config } = useApplicationContext();
  const list = config.get<string>('moderation.QualityLevelTooltip') || '';
  const tooltip = list.split(',');

  if (!isSuperAgent && !isSuperHost) {
    return null;
  }

  return <SuperAgentLevelView isSuperAgent={isSuperAgent} tooltip={tooltip} />;
};
